import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyLocationViewQuery,
  useLocationAddMutation,
  useLocationEditMutation,
  useLazyGetlocationQuery,
  useLazyGetStateCitiesQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const LocationPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;

  const [name, setName] = useState("");
  const [states, setStates] = useState("");
  const [city, setCity] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [statesErr, setStatesErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);
  const [btn, setBtn] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

  // RTK QUERY
  const [locationAddApi] = useLocationAddMutation();
  const [locationEditApi] = useLocationEditMutation();
  const [locationViewApi] = useLazyLocationViewQuery();
  const [stateGetApi] = useLazyGetlocationQuery();
  const [getStateCities] = useLazyGetStateCitiesQuery();

  const submitHandler = () => {
    if (name?.length == 0 || city?.length == 0 || states?.length == 0) {
      setNameErr(true);
      setStatesErr(true);
      setCityErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("name", name);
      formdata.append("state_id", states);
      formdata.append("city_id", city);

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        formdata.append("_method", "PUT");
        locationEditApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/locations");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err");
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        locationAddApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status === "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/locations");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.error("Error", err);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    locationViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          setName(res?.location?.name);
          setStates(res?.location?.city?.state_id);
          setCity(res?.location?.city_id);
          getCities(res?.location?.city_id);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  const getState = () => {
    dispatch(saveLoader(true));
    stateGetApi()
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          setStateList(res?.states);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  const getCities = (id) => {
    dispatch(saveLoader(true));
    getStateCities(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          setCitiesList(res?.cities);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
    getState();
  }, []);

  const handleState = (value) => {
    setStates(value);
    getCities(value);
    setCity("");
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={types == "edit" ? "edit-city" : "add-city"} />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  States
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => {
                    handleState(e.target.value);
                  }}
                  value={states}
                >
                  <option value={""} disabled>
                    Select States
                  </option>
                  {stateList?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {states?.length == 0 && statesErr && (
                <p className="err">Select States</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  City
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setCity(e.target.value)}
                  value={city}
                >
                  <option value={""} disabled>
                    Select City
                  </option>
                  {citiesList?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {states?.length == 0 && statesErr && (
                <p className="err">Select City</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Location Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Location Name</p>
              )}
            </div>
          </Row>
          <Row>
            <div className="col-md-12 text-start mx-3 mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default LocationPage;
